/**
 * Created by Ewald Stamp (ewald.stamp@netmills.de) on 05.03.15.
 */

angular
  .module('farmnet.partner.fendt')
  .controller('FendtVarioDocButtonController', [
    '$scope',
    'externalAccounts',
    'fendtVarioDocAlerts',
    'fendtVarioDocService',
    'fendtVarioDocLocale',
    function(
      $scope,
      externalAccounts,
      fendtVarioDocAlerts,
      fendtVarioDocService,
      fendtVarioDocLocale
    ) {
      'use strict';

      var AGCO_MANUFACTURER_CODE = 102;
      var FENDT_VARIO_DOC_ACCOUNT = 'fendt.varioDoc';

      $scope.isVisible = false;
      $scope.locale = fendtVarioDocLocale;

      var imageUrls = {
        varioDoc: 'img/partner/fendt/VarioDoc.svg',
        taskDoc: 'img/partner/fendt/TaskDoc.svg',
        combined: 'img/partner/fendt/Combined.svg'
      };

      $scope.imageUrl = imageUrls.combined;

      function machineUpdated() {
        $scope.isVisible = false;

        //// Prerequisites

        if (!$scope.machine) {
          return;
        }

        var machine = $scope.machine;

        if (!machine.sysManufacturer) {
          return;
        }

        if (machine.sysManufacturer.code !== AGCO_MANUFACTURER_CODE) {
          return;
        }

        if (machine.serialnumber === null || machine.serialnumber === '') {
          return;
        }

        //// we have now: AGCO machine with ISO XML and set serial number

        function isVarioDocMachine(name) {
          name = name.toLowerCase();
          return name.indexOf('fendt') !== -1;
        }

        function isTaskDocMachine(name) {
          name = name.toLowerCase();
          return (
            name.indexOf('mf ') === 0 ||
            name.indexOf('massey ferguson') !== -1 ||
            name.indexOf('valtra') !== -1 ||
            name.indexOf('challenger') !== -1
          );
        }

        function setImage(machine) {
          if (isVarioDocMachine(machine.name)) {
            $scope.imageUrl = imageUrls.varioDoc;
          } else if (isTaskDocMachine(machine.name)) {
            $scope.imageUrl = imageUrls.taskDoc;
          } else {
            $scope.imageUrl = imageUrls.combined;
          }
        }

        return externalAccounts
          .hasCredentials(FENDT_VARIO_DOC_ACCOUNT)
          .then(function(hasCredentials) {
            if (hasCredentials) {
              // check if machine is registered
              return fendtVarioDocService
                .isRegistered(machine.serialnumber)
                .then(function(isRegistered) {
                  if (isRegistered) {
                    $scope.isVisible = true;
                    $scope.state.sendData = true;
                    $scope.state.validMachinesCount++;

                    setImage($scope.machine);
                  } else {
                    $scope.isVisible = false;
                  }
                });
            } else {
              $scope.isVisible = false;
              return false;
            }
          })
          .catch(function() {
            $scope.isVisible = false;
          });
      }

      $scope.showInfo = function() {
        fendtVarioDocAlerts.showWillSendData();
      };

      $scope.$watch('machine', machineUpdated);

      $scope.$on('$destroy', function() {
        if ($scope.isVisible) {
          $scope.isVisible = false;
          $scope.state.validMachinesCount--;
        }

        if ($scope.state.validMachinesCount <= 0) {
          $scope.state.validMachinesCount = 0;
          $scope.state.sendData = false;
        }
      });
    }
  ]);
